<template>
  <div class="cy-electricity">
    <div v-html="$t('electricity.sockets.description')"></div>
    <SwitchesSocketsSerieSelector />
    <ElectricityOptions />
  </div>
</template>

<script>
import ElectricityOptions from "@/components/electricity/ElectricityOptions";
import SwitchesSocketsSerieSelector from "@/components/electricity/SwitchesSocketsSerieSelector";
export default {
  components: {
    SwitchesSocketsSerieSelector,
    ElectricityOptions,
  },
};
</script>
